import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOUR_MEALBOX: "Din matkasse",
      SIZE: "Størrelse",
      FORMAT_PORTIONS_MEALS: ({
        portions,
        meals,
      }: {
        portions: number;
        meals: number;
      }) => `${portions} pers, ${meals} retter`,
      PRICE_PER_PORTION: "Pris per porsjon",
      CHANGE_SIZE: "Endre størrelse",
      PREFERENCES: "Preferanser",
      NO_PREFERENCES_WARNING:
        "Still inn dine preferanser og få flere personlige menyforslag",
      CHANGE_MEALBOX: "Endre din matkasse",
    },
    se: {
      YOUR_MEALBOX: "Din matkasse",
      SIZE: "Storlek",
      FORMAT_PORTIONS_MEALS: ({
        portions,
        meals,
      }: {
        portions: number;
        meals: number;
      }) => `${portions} pers, ${meals} rätter`,
      PRICE_PER_PORTION: "Pris per portion",
      CHANGE_SIZE: "Ändra storlek",
      PREFERENCES: "Preferenser",
      NO_PREFERENCES_WARNING:
        "Ställ in dina preferenser och få mer personliga menyförslag.",
      CHANGE_MEALBOX: "Ändra din matkasse",
    },
    dk: {
      YOUR_MEALBOX: "Din måltidskasse",
      SIZE: "Størrelse",
      FORMAT_PORTIONS_MEALS: ({
        portions,
        meals,
      }: {
        portions: number;
        meals: number;
      }) => `${portions} pers, ${meals} retter`,
      PRICE_PER_PORTION: "Pris pr. portion",
      CHANGE_SIZE: "Ændr størrelse",
      PREFERENCES: "Præferencer",
      NO_PREFERENCES_WARNING:
        "Indstil dine præferencer og få flere personlige menuforslag.",
      CHANGE_MEALBOX: "Ændr din måltidskasse",
    },
  } as const
)[language];
